import {
    GET_USER_PROFILE_PHOTO_SUCCESS,
    // GET_USER_PROFILE_PHOTO_ERROR,
    UPDATE_USER_PROFILE_INFORMATION_SUCCESS,
    // UPDATE_USER_PROFILE_INFORMATION_ERROR,
    REGISTER_ACTIVATE_ACCOUNT_SUCCESS,
    GET_USER_BENEFIT_CONFIG_SUCCESS,
    // GET_USER_BENEFIT_CONFIG_ERROR,
    GET_USER_NOTIFICATIONS_SUCCESS,
    // GET_USER_NOTIFICATIONS_ERROR,
    GET_USER_BENEFIT_PLAN_SUCCESS,
    // GET_USER_BENEFIT_PLAN_ERROR,
    GET_USER_CONFIG_BENEFIT_REQUEST,
    GET_USER_CONFIG_BENEFIT_SUCCESS,
    // GET_USER_CONFIG_BENEFIT_ERROR,
    DO_LOGIN_SUCCESS,
    LOGOUT_USER_SUCCESS,
    LOGOUT_USER_ERROR,
    VERIFY_LOGIN_EMAIL_OTP_SUCCESS,
    UPDATE_USER_TOKEN_EXPIRED_ERROR,
    RESET_USER_DATA,
    GET_AUDIT_USER_REQUEST,
    GET_AUDIT_USER_SUCCESS,
    GET_AUDIT_USER_FAILURE,
    UPDATE_USER_CHANGE_PASSWORD_SUCCESS
} from '../actions';

const initialState = {
    user: null,
    restrictOTP: null,
    loggedIn: false,
    profilePhoto: null,
    error: false,
    errorObject: null,
    benefits: {},
    benefitPlans: {},
    hasUnreadMessages: false,
    notifications: [],
    configBenefit: null,
    tokenHasExpired: false,
    userAudit:[],
    loading:false
};

export default function userReducer(state = initialState, action) {
    switch (action.type) {
        case GET_USER_CONFIG_BENEFIT_REQUEST:
            return { ...state, configBenefit: null };

        case GET_USER_CONFIG_BENEFIT_SUCCESS:
            return { ...state, configBenefit: action.payload.data.benefitConfig };

        case GET_USER_BENEFIT_PLAN_SUCCESS:
            return {
                ...state,
                benefitPlans: {
                    ...state.benefitPlans,
                    [action.payload.userId]: action.payload.response.data
                }
            };

        case GET_USER_NOTIFICATIONS_SUCCESS: {
            const { hasUnreadMessages, notifications } = action.payload.data;
            return { ...state, hasUnreadMessages, notifications };
        }

        case GET_USER_BENEFIT_CONFIG_SUCCESS:
            return {
                ...state,
                benefits: {
                    ...state.benefits,
                    [action.payload.userId]: action.payload.response.data.benefit
                }
            };

        case UPDATE_USER_PROFILE_INFORMATION_SUCCESS:
        case REGISTER_ACTIVATE_ACCOUNT_SUCCESS:
            return { ...state, user: action.payload.data.user };

        case GET_USER_PROFILE_PHOTO_SUCCESS: {
            const imageType = action.payload.headers['content-type'];
            const base64 = new Buffer(action.payload.data, 'binary').toString('base64');
            return { ...state, profilePhoto: `data:${imageType};base64,${base64}` };
        }

        case DO_LOGIN_SUCCESS:
            return {
                ...state,
                user: action.payload.data.user,
                restrictOTP: action.payload.data.restrictOTP
            };

        case LOGOUT_USER_SUCCESS:
        case RESET_USER_DATA:
            return { ...state, user: null };

        case LOGOUT_USER_ERROR:
            return { ...state, error: action.payload, loading: false };

        case UPDATE_USER_TOKEN_EXPIRED_ERROR:
            return { ...state, tokenHasExpired: true };

        case VERIFY_LOGIN_EMAIL_OTP_SUCCESS:
            return {
                ...state,
                user: { ...state.user, accessToken: action.payload.data.accessToken }
            };

        case GET_AUDIT_USER_REQUEST:
            return { ...state, loading: true, userAudit: [] };

        case GET_AUDIT_USER_SUCCESS:
            return { ...state, userAudit: action.payload, error: false, loading: false };

        case GET_AUDIT_USER_FAILURE:
            return { ...state, error: action.payload, loading: false };

        case UPDATE_USER_CHANGE_PASSWORD_SUCCESS:
            return { ...state, user: { ...state.user, status: 100 } };

        default:
            return state;
    }
}
